var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"allocine-rating"},[_c('div',{ref:"ratingBackground",staticClass:"rating-background"}),_vm._v(" "),_c('div',{staticClass:"full-bar"})])}
var staticRenderFns = []

export { render, staticRenderFns }